var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExpenses = function SvgExpenses(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#expenses_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#101828",
    clipPath: "url(#expenses_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 8,
    x: 5,
    y: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 8,
    x: 2,
    y: 7,
    rx: 1,
    transform: "rotate(-90 2 7)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 8,
    x: 8.121,
    y: 14.465,
    rx: 1,
    transform: "rotate(45 8.121 14.465)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 8,
    x: 2.464,
    y: 15.879,
    rx: 1,
    transform: "rotate(-45 2.464 15.879)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 8,
    x: 14,
    y: 7,
    rx: 1,
    transform: "rotate(-90 14 7)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 8,
    x: 14,
    y: 18,
    rx: 1,
    transform: "rotate(-90 14 18)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 8,
    x: 14,
    y: 20.769,
    rx: 1,
    transform: "rotate(-90 14 20.77)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "expenses_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "expenses_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgExpenses;